import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { List as ImmutableList, List } from 'immutable';
import { LocalStorageService } from '../../cache';
import {
    DreamTeamCrossFunctionId,
    DreamTeamCrossFunctionIdDisplay,
    DreamTeamFunctionDisplay,
    DreamTeamFunctionType,
    DreamTeamImprovementDisplay,
    getSortedDreamTeamCrossFunctionList,
    getSortedDreamTeamFunctionList,
    getSortedDreamTeamImprovementDisplayInfoList,
    TeamImprovementId
} from '../../constants-types';
import {
    Group,
    GroupUpdate,
    IconSize,
    IconType,
    InvitationSource,
    Person,
    SearchResult
} from '../../core-data-model';
import {
    GroupsDataService,
    notification,
    SlackNotificationService,
    SlackNotificationTypes
} from '../../core-services';
import { Util } from '../../core-utilities';
import { InitDataService } from '../../system-services';
import { TranslationService } from '../../translations';

@Component({
    selector: 'group-edit',
    template: `
        <div
            style="width: 585px; padding-bottom: 123px;"
            [ngClass]="getGroupEditStyle()"
            piTesting="group-edit"
        >
            <div class="title-dashboard" style="margin-bottom: 35px">
                {{ getTitleText() }}
            </div>
            <div>
                @if (displayEditForm()) {
                    <div class="form-group">
                        <label class="control-label" style="display:block">
                            <span style="margin-bottom:10px">{{
                                'teams.nameTeam' | translate
                            }}</span>
                            @if (nameExists(groupName)) {
                                <span
                                    data-testing="group-exists-warning"
                                    class="errorColor"
                                    style="margin-left: 10px;"
                                >
                                    {{ 'groups.nameExists' | translate }}
                                </span>
                            }
                            @if (nameLengthExceeds(groupName)) {
                                <span
                                    data-testing="group-name-length-warning"
                                    class="errorColor"
                                    style="margin-left: 10px;"
                                >
                                    {{
                                        'groups.namelengthexceeds'
                                            | translateFormat
                                                : groups.groupNameLengthLimit
                                    }}
                                </span>
                            }
                            <input
                                data-testing="teamName"
                                id="groupName"
                                [(ngModel)]="groupName"
                                ngDefaultControl
                                style="width: 400px; padding:25px"
                                [disabled]="isProcessing"
                                type="text"
                                class="form-control"
                                [placeholder]="
                                    'label.myTeams.team-name' | translate
                                "
                            />
                        </label>
                    </div>
                }
                @if (getTakeAssessmentStatus()) {
                    <div style="margin-bttom:30px">
                        <div class="layoutLastPushedRight-X layout--center">
                            <div
                                class="takeBA_container border-color-neutral-400 bg-color-neutral-50"
                            >
                                <div class="layoutLastPushedRight-X">
                                    <img
                                        class="assessment-image"
                                        src="/Assets/Design/HubTakeAssessment.svg"
                                    />
                                    <div class="layoutVertical">
                                        <span
                                            class="largeLabelText"
                                            style="margin: 5px 0px 5px"
                                        >
                                            {{
                                                'hubSpoke-inlineba-title'
                                                    | translate
                                            }}
                                        </span>
                                        <div
                                            class="copy-lg"
                                            style="margin: 0px 0px 10px"
                                        >
                                            {{
                                                'hubSpoke-inlineba-body'
                                                    | translate
                                            }}
                                        </div>
                                        <div>
                                            <button
                                                class="button button-primary button-md"
                                                (click)="takeAssessment()"
                                            >
                                                {{
                                                    'hubSpoke-inlineba-button'
                                                        | translate
                                                }}
                                            </button>
                                            <span class="copy-lg"> or </span>
                                            <a
                                                class="skip_selector fontWeight500"
                                                (click)="skipAssessment()"
                                                >{{
                                                    'hubSpoke-inlineba-skip'
                                                        | translate
                                                }}</a
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="smallText italicText color-neutral-700 layoutVertical"
                                    style="margin: 10px 0"
                                >
                                    {{
                                        'hubSpoke-inlineba-footnote' | translate
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (displayEditForm()) {
                    <div style="margin-bottom:30px">
                        <div class="layoutLastPushedRight-X layout--center">
                            <label class="extraSmallText">
                                {{ 'teams.label-team-members' | translate }}
                            </label>
                            <button
                                class="button button-link button-sm"
                                (click)="isCreatingPerson = !isCreatingPerson"
                                data-testing="addTeamMember"
                                [disabled]="isCreatingPerson"
                            >
                                <span class="smallText">
                                    <abstract-icon
                                        style="margin-right: 2px;"
                                        [iconType]="IconType.Add"
                                        [iconSize]="IconSize.Small"
                                    >
                                    </abstract-icon>
                                    {{ 'label.edit-team.add' | translate }}
                                </span>
                            </button>
                        </div>
                        @if (!isSelfServe) {
                            @if (isCreatingPerson) {
                                <create-person-form
                                    (createdPerson)="addResult($event)"
                                    (close)="isCreatingPerson = false"
                                    [invitationSource]="invitationSource"
                                ></create-person-form>
                            }
                        } @else {
                            @if (isCreatingPerson) {
                                <create-selfserve-person-form
                                    (createdPerson)="addResult($event)"
                                    [showCloseButton]="true"
                                    [teamId]="myGroup.id"
                                    (close)="isCreatingPerson = false"
                                ></create-selfserve-person-form>
                            }
                        }
                        @if (!isCreatingPerson) {
                            <add-to-group-pillbox
                                [isCreatingGroup]="isCreatingGroup"
                                [isProcessing]="isProcessing"
                                [groupSet]="groupSet"
                                (onAdded)="addResult($event)"
                                (onRemove)="removeResult($event)"
                                (resetBoundValue)="resetBoundValue()"
                                data-testing="add-to-group-pillbox"
                            >
                            </add-to-group-pillbox>
                        }
                    </div>
                }
                @if (showAdditionalQuestions()) {
                    <div class="form-group" data-testing="additional questions">
                        <label class="control-label">
                            <span style="margin-bottom:10px"
                                >{{
                                    'teamConfig.team-crossFunction.input-title'
                                        | translate
                                }}
                                <span class="label-help"
                                    >({{
                                        'label.common-terms.optional'
                                            | translate
                                    }})
                                </span>
                            </span>
                            <span class="select">
                                <ok-select
                                    data-testing="crossFunctionId"
                                    [(ngModel)]="teamCrossFunctionIdChosen"
                                    ngDefaultControl
                                    [options]="teamCrossFunctionIdDisplays"
                                    [disabled]="isProcessing"
                                    [displayOnlyPlaceholderValue]="
                                        teamCrossFunctionIdChosen
                                    "
                                >
                                    <ng-template
                                        let-option="option"
                                        data-testing="crossFunctionIdOptions"
                                    >
                                        {{ option.display }}
                                    </ng-template>
                                </ok-select>
                            </span>
                        </label>
                    </div>
                    <div class="form-group">
                        <label class="control-label">
                            <span style="margin-bottom:10px"
                                >{{
                                    'teamConfig.team-function.input-title'
                                        | translate
                                }}
                                <span class="label-help"
                                    >({{
                                        'label.common-terms.optional'
                                            | translate
                                    }})
                                </span>
                            </span>
                            <span class="select">
                                <ok-select
                                    data-testing="teamFunctionType"
                                    [(ngModel)]="teamFunctionChosen"
                                    ngDefaultControl
                                    [options]="teamFunctionDisplays"
                                    [disabled]="isProcessing"
                                    [displayOnlyPlaceholderValue]="
                                        teamFunctionChosen
                                    "
                                >
                                    <ng-template
                                        let-option="option"
                                        data-testing="teamFunctionTypeOptions"
                                    >
                                        {{ option.display }}
                                    </ng-template>
                                </ok-select>
                            </span>
                            @if (
                                teamFunctionChosen.teamFunctionType ===
                                otherTeamFunctionType
                            ) {
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="{{
                                        'teamConfig.team-function.other-area-placeholder'
                                            | translate
                                    }}"
                                    [(ngModel)]="otherTeamFunction"
                                    ngDefaultControl
                                    maxlength="100"
                                    data-testing="otherTeamFunction"
                                    [disabled]="isProcessing"
                                />
                            }
                        </label>
                    </div>
                    <div class="form-group">
                        <label class="control-label">
                            <span style="margin-bottom:10px"
                                >{{
                                    'teamConfig.team-improvement.input-title'
                                        | translate
                                }}
                                <span class="label-help"
                                    >({{
                                        'label.common-terms.optional'
                                            | translate
                                    }})
                                </span>
                            </span>
                            <span class="select">
                                <ok-select
                                    data-testing="teamImprovement"
                                    [(ngModel)]="teamImprovementChosen"
                                    ngDefaultControl
                                    [options]="teamImprovementDisplays"
                                    [disabled]="isProcessing"
                                    [displayOnlyPlaceholderValue]="
                                        teamImprovementChosen
                                    "
                                >
                                    <ng-template
                                        let-option="option"
                                        data-testing="teamImprovementIdOptions"
                                    >
                                        {{ option.display }}
                                    </ng-template>
                                </ok-select>
                            </span>
                            @if (
                                teamImprovementChosen.teamImprovementId ===
                                otherTeamImprovementId
                            ) {
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="{{
                                        'teamConfig.team-improvement.other-area-placeholder'
                                            | translate
                                    }}"
                                    [(ngModel)]="otherTeamImprovementArea"
                                    ngDefaultControl
                                    maxlength="100"
                                    data-testing="otherTeamImprovement"
                                    [disabled]="isProcessing"
                                />
                            }
                        </label>
                    </div>
                }
            </div>
            @if (getAssessmentFooter() && isSelfServe) {
                <div class="takeBA_flexContainer">
                    <div class="takeBA_flexGrow"></div>
                    <hr class="basicLine takeBA_footerLine" />
                    <div
                        class="layoutLastPushedRight-X layout--center"
                        class="takeBA_footer"
                    >
                        <div>
                            <div class="layoutLastPushedRight-X">
                                <img
                                    class="assessment-image"
                                    src="/Assets/Design/HubTakeAssessment.svg"
                                />
                                <div class="layoutVertical">
                                    <span
                                        class="largeLabelText"
                                        style="margin: 5px 0px 5px"
                                    >
                                        {{
                                            'hubSpoke-inlineba-footer-title'
                                                | translate
                                        }}
                                    </span>
                                    <div class="copy-lg">
                                        {{
                                            'hubSpoke-inlineba-footer-body'
                                                | translate
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="layoutVertical takeBA_footerButton">
                                <button
                                    class="button button-tertiary button-md"
                                    (click)="takeAssessment()"
                                >
                                    {{ 'hubSpoke-inlineba-button' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <hr class="basicLine groupEditLine" />
            <div
                class="form_row layoutHorizontalSpaceBetween groupEditButtonSection"
                [ngStyle]="{
                    'flex-direction': myGroup ? 'row-reverse' : 'row'
                }"
            >
                <button
                    piTesting="save-new-team"
                    type="button"
                    class="button button-primary button-md"
                    [disabled]="!readyToSave()"
                    (click)="saveAndClose()"
                    [ngClass]="{
                        'button--loading ': isProcessing
                    }"
                >
                    {{ getButtonText() }}
                </button>
                <button
                    type="button"
                    class="button button-tertiary button-md"
                    (click)="cancel.emit()"
                    piTesting="cancel-new-team"
                >
                    {{ 'text.common-terms.cancel' | translate }}
                </button>
            </div>
        </div>
    `,
    styles: [
        `
            .groupEditLine {
                position: fixed;
                width: 500px;
                bottom: 80px;
            }
            .groupEditButtonSection {
                position: fixed;
                width: 500px;
                background: white;
                padding: 15px 15px 20px 15px;
                bottom: 0;
                margin-bottom: 0;
            }
            .takeBA_container {
                padding: 20px 30px 30px 30px;
                border-width: 2px;
                border-style: solid;
                border-radius: 5px;
            }
            .takeBA_footerLine {
                display: flex;
                width: 500px;
            }
            .takeBA_footer {
                background-color: white;
                display: flex;
            }
            .takeBA_footerButton {
                margin: 10px 0px 0px 0px;
                width: 35%;
            }
            .takeBA_flexGrow {
                flex-grow: 1;
            }
            .takeBA_flexContainer {
                display: flex;
                flex-direction: column;
                height: 100vh;
            }
            .skip_selector {
                cursor: pointer;
            }
            .assessment-image {
                width: 110px;
                vertical-align: middle;
                margin-right: 15px;
            }
            .selfServeForm {
                display: flex;
                flex-direction: column;
                overflow-y: auto;
                height: calc(100vh - 50px);
            }
        `
    ],
    standalone: false
})
export class GroupEditComponent implements OnChanges {
    @Input()
    myGroup: Group;
    @Input()
    groupSet: List<any> = ImmutableList();
    @Input()
    isCreatingGroup = false;
    @Input()
    invitationSource: InvitationSource = InvitationSource.Unknown;
    @Input()
    isSelfServe = false;
    @Input()
    groupName = '';
    @Input()
    displayTakeAssessment = false;
    @Output()
    saveHit = new EventEmitter<string>();
    @Output()
    cancel = new EventEmitter<void>();
    @Output()
    groupChanged = new EventEmitter<void>();
    @Output()
    takeAssessmentFn = new EventEmitter<void>();
    @Output()
    groupPeopleCount = new EventEmitter<void>();
    @Output()
    optionalQuestionAnswered = new EventEmitter<void>();

    isProcessing = false;
    isCreatingPerson = false;

    addedDelta: SearchResult[] = [];
    removedDelta: SearchResult[] = [];

    IconType = IconType;
    IconSize = IconSize;

    teamFunctionDisplays: DreamTeamFunctionDisplay[] = [];
    teamFunctionChosen: DreamTeamFunctionDisplay;
    otherTeamFunction: string;
    otherTeamFunctionType: DreamTeamFunctionType = DreamTeamFunctionType.Other;

    teamCrossFunctionIdDisplays: DreamTeamCrossFunctionIdDisplay[] = [];
    teamCrossFunctionIdChosen: DreamTeamCrossFunctionIdDisplay;

    teamImprovementDisplays: DreamTeamImprovementDisplay[] = [];
    teamImprovementChosen: DreamTeamImprovementDisplay;
    otherTeamImprovementId: TeamImprovementId = TeamImprovementId.Other;
    otherTeamImprovementArea: string;
    isPersonPage = false;
    showSkipAssessmentFooterKey = 'showSkipAssessmentFooter';

    // Chaining promises to ensure that saveGroup calls are executed sequentially, one after the other.
    private saveGroupPromise: Promise<void> = Promise.resolve();

    constructor(
        public TR: TranslationService,
        public util: Util,
        public groups: GroupsDataService,
        private slackNotification: SlackNotificationService,
        private router: Router,
        private localStorageService: LocalStorageService,
        private initData: InitDataService
    ) {
        // Initialize lists of options
        this.teamFunctionDisplays = getSortedDreamTeamFunctionList((key) =>
            this.TR.key(key)
        );
        this.teamCrossFunctionIdDisplays = getSortedDreamTeamCrossFunctionList(
            (key) => this.TR.key(key)
        );
        this.teamImprovementDisplays =
            getSortedDreamTeamImprovementDisplayInfoList((key) =>
                this.TR.key(key)
            );

        // Default these to Unknown
        this.resetTeamFunctionChosen();
        this.resetTeamCrossFunctionIdChosen();
        this.resetTeamImprovementChosen();

        this.isPersonPage = this.router.url.includes('person');
    }

    get isValidOtherTeamFunction() {
        return this.otherTeamFunction?.length > 0;
    }

    get isValidOtherTeamImprovement() {
        return this.otherTeamImprovementArea?.length > 0;
    }

    ngOnChanges(changes: SimpleChanges) {
        // When the group changes sync up our component's internal state
        if (
            this.myGroup &&
            changes.myGroup &&
            changes.myGroup.currentValue !== changes.myGroup.previousValue
        ) {
            this.groupName = this.myGroup.name;

            this.updateTeamImprovementFromGroup(this.myGroup);
            this.updateTeamFunctionChosenFromGroup(this.myGroup);
            this.updateTeamCrossFunctionIdChosenFromGroup(this.myGroup);
        }

        // If SelfServe display add person component when Luke is only team member
        if (
            this.isSelfServe &&
            this.peopleAndJobCountChange(changes) &&
            (this.IsLoggedInUserOnlyTeamMember() ||
                this.myGroup.peopleAndJobCount === 0)
        ) {
            this.isCreatingPerson = true;
        }

        // What use case is this supposed to cover? Do we need this?
        if (
            changes.groupSet &&
            changes.groupSet.currentValue !== changes.groupSet.previousValue
        ) {
            this.resetDelta();
        }
    }

    getTitleText(): string {
        if (
            this.getTakeAssessmentStatus() ||
            (this.displayEditForm() &&
                this.isSelfServe &&
                this.isCreatingPerson)
        ) {
            return this.TR.key('hubSpoke-manageTeam-addTeammates');
        } else {
            return this.TR.key(
                this.isCreatingGroup
                    ? 'label.myTeams.placeholder.create-new-team'
                    : 'label.myTeams.edit-team-header'
            );
        }
    }

    getButtonText(): string {
        return this.isCreatingGroup
            ? this.TR.key('teams.createTeam')
            : this.TR.key('text.common-terms.save');
    }

    async addResult(result: SearchResult) {
        const index = this.removedDelta.findIndex((r) => result.id === r.id);

        // If group size is 1 in self service and someone is added, send slack notification.
        if (this.isSelfServe && this.groupSet.size === 1) {
            this.slackNotification.callNotificationWebhook(
                SlackNotificationTypes.AddedFirstTeamMember
            );
        }

        this.groupSet = this.groupSet.push(result);
        if (index > -1) {
            this.removedDelta.splice(index, 1);
        } else {
            this.addedDelta.push(result);
        }
        // For existing teams we want to immediately sync up adding team members
        if (this.myGroup) {
            this.saveGroupPromise = this.saveGroupPromise.then(() =>
                this.saveGroup()
            );
            await this.saveGroupPromise;
        }
    }

    resetBoundValue() {
        // This is needed because you need to remove entries (groups) that have percolated
        // up, but shouldn't be included. You need to toArray or else optimizations will
        // not truly create a new list
        this.groupSet = ImmutableList(this.groupSet.toArray());
    }

    async removeResult(result: SearchResult) {
        const indexInAlpha = this.addedDelta.findIndex(
            (r) => result.id === r.id
        );
        const index = this.groupSet.findIndex((r) => result.id === r.id);

        this.groupSet = this.groupSet.splice(index, 1);
        if (indexInAlpha > -1) {
            this.addedDelta.splice(indexInAlpha, 1);
        } else {
            this.removedDelta.push(result);
        }
        // For existing teams we want to immediately sync up removing team members
        if (this.myGroup) {
            this.saveGroupPromise = this.saveGroupPromise.then(() =>
                this.saveGroup()
            );
            await this.saveGroupPromise;
        }
    }

    readyToSave() {
        if (
            this.teamFunctionChosen.teamFunctionType ===
                this.otherTeamFunctionType &&
            !this.isValidOtherTeamFunction
        ) {
            return false;
        }
        if (
            this.teamImprovementChosen.teamImprovementId ===
                this.otherTeamImprovementId &&
            !this.isValidOtherTeamImprovement
        ) {
            return false;
        }
        return (
            !this.nameExists(this.groupName) &&
            !this.nameLengthExceeds(this.groupName)
        );
    }

    nameExists(matchName: string): boolean {
        const trimmed = matchName.trim();
        if (this.isProcessing || !trimmed) {
            return false;
        }
        return this.groups.nameExists(matchName, this.myGroup);
    }

    nameLengthExceeds(matchName: string): boolean {
        const trimmed = matchName.trim();
        if (this.isProcessing || !trimmed) {
            return false;
        }
        return this.groups.nameLengthExceeds(matchName);
    }

    @notification('groupsupdated.success-title', 'teamsUpdated.success-message')
    async updateGroup(): Promise<void> {
        return this.updateGroupUndecorated();
    }

    // We have to do this for tests
    async updateGroupUndecorated(): Promise<void> {
        // If someone changes the team function type turn off the strategy auto selection flag otherwise leave it be
        let isStrategyAutoSelectionEnabled =
            this.myGroup.isStrategyAutoSelectionEnabled;
        if (
            this.teamFunctionChosen.teamFunctionType !==
            this.myGroup.teamFunctionType
        ) {
            isStrategyAutoSelectionEnabled = false;
        }

        await this.groups.updateGroup(
            new GroupUpdate(this.myGroup, {
                isStrategyAutoSelectionEnabled,
                name: this.groupName,
                teamFunctionType: this.teamFunctionChosen.teamFunctionType,
                otherTeamFunction:
                    this.teamFunctionChosen.teamFunctionType ===
                    DreamTeamFunctionType.Other
                        ? this.otherTeamFunction
                        : null,
                crossFunctionId: this.teamCrossFunctionIdChosen.crossFunctionId,
                // the backend expects an array of teamImprovementIds
                teamImprovementIds: this.convertObjectToTeamImprovementIdsArray(
                    [this.teamImprovementChosen]
                ),
                otherTeamImprovement:
                    this.teamImprovementChosen.teamImprovementId ===
                    TeamImprovementId.Other
                        ? this.otherTeamImprovementArea
                        : null
            })
        );
        if (this.addedDelta.length > 0) {
            await this.groups.addEntitiesToGroup(this.myGroup, this.addedDelta);
        }
        if (this.removedDelta.length > 0) {
            await this.groups.removeEntitiesFromGroup(
                this.myGroup,
                this.removedDelta
            );
        }
        this.groupChanged.emit();
    }

    async createGroup(): Promise<Group> {
        const newGroup = await this.groups.createGroup(
            this.groupName,
            this.teamFunctionChosen.teamFunctionType,
            this.teamFunctionChosen.teamFunctionType ===
                DreamTeamFunctionType.Other
                ? this.otherTeamFunction
                : null,
            this.teamCrossFunctionIdChosen.crossFunctionId,
            // update when multiple select is enabled for team improvement
            this.convertObjectToTeamImprovementIdsArray([
                this.teamImprovementChosen
            ]),
            this.teamImprovementChosen.teamImprovementId ===
                TeamImprovementId.Other
                ? this.otherTeamImprovementArea
                : null
        );

        if (this.groupSet.size > 0) {
            await this.groups.addEntitiesToGroup(
                newGroup,
                this.groupSet.toArray()
            );
        }
        return newGroup;
    }

    async saveGroup() {
        this.isProcessing = true;
        try {
            if (this.myGroup) {
                await this.updateGroup();
                if (this.groupPeopleCountMatched(false)) {
                    this.groupPeopleCount.emit();
                }
                this.anyOptionalQuestionsAnswered(false);
            } else {
                this.myGroup = await this.createGroup();
                if (this.groupPeopleCountMatched(true)) {
                    this.groupPeopleCount.emit();
                }
                this.anyOptionalQuestionsAnswered(true);
            }
        } finally {
            this.isProcessing = false;
        }
        this.resetDelta();
    }

    // For creating group, check only once on the size of groupSet
    // For updating group, with automatically saving on every adding/removing, we just need to check the delta value of 1
    groupPeopleCountMatched(isCreating: boolean): boolean {
        const teamScorePeopleCount = 3;
        return isCreating
            ? this.groupSet.size >= teamScorePeopleCount
            : (this.addedDelta.length > 0 &&
                  this.myGroup.peopleAndJobCount + 1 >= teamScorePeopleCount) ||
                  (this.removedDelta.length > 0 &&
                      this.myGroup.peopleAndJobCount - 1 >=
                          teamScorePeopleCount) ||
                  (this.addedDelta.length === 0 &&
                      this.removedDelta.length === 0 &&
                      this.myGroup.peopleAndJobCount >= teamScorePeopleCount);
    }

    // Optional questions are saved as local variables until passing to API for updating group
    // For creating group, check local variables for optional questions
    // For updating group, check existing question answer, emit output when existing answer is unknown
    anyOptionalQuestionsAnswered(isCreating: boolean): void {
        if (
            this.teamCrossFunctionIdChosen.crossFunctionId !==
            DreamTeamCrossFunctionId.Unknown
        ) {
            if (isCreating) {
                this.optionalQuestionAnswered.emit();
            } else {
                if (
                    this.myGroup.crossFunctionId ===
                    DreamTeamCrossFunctionId.Unknown
                ) {
                    this.optionalQuestionAnswered.emit();
                }
            }
        }
        if (
            this.teamFunctionChosen.teamFunctionType !==
            DreamTeamFunctionType.Unknown
        ) {
            if (isCreating) {
                this.optionalQuestionAnswered.emit();
            } else {
                if (
                    this.myGroup.teamFunctionType ===
                    DreamTeamFunctionType.Unknown
                ) {
                    this.optionalQuestionAnswered.emit();
                }
            }
        }
        if (
            this.teamImprovementChosen?.teamImprovementId !==
            TeamImprovementId.Unknown
        ) {
            if (isCreating) {
                this.optionalQuestionAnswered.emit();
            } else {
                if (
                    this.myGroup.teamImprovementIds[0] === undefined ||
                    this.myGroup.teamImprovementIds[0] ===
                        TeamImprovementId.Unknown
                ) {
                    this.optionalQuestionAnswered.emit();
                }
            }
        }
    }

    async saveAndClose() {
        this.saveGroupPromise = this.saveGroupPromise.then(() =>
            this.saveGroup()
        );
        await this.saveGroupPromise;
        this.saveHit.emit(this.myGroup.id);
    }

    showAdditionalQuestions() {
        return !(this.isPersonPage || this.isSelfServe);
    }

    IsLoggedInUserOnlyTeamMember(): boolean {
        const teamMemebers = this.groupSet as List<Person>;
        return (
            teamMemebers.count() <= 1 &&
            teamMemebers?.first<Person>()?.id ===
                this.initData.user.surveyUserId
        );
    }

    peopleAndJobCountChange(changes: SimpleChanges): boolean {
        return (
            changes.myGroup &&
            (changes.myGroup.firstChange ||
                changes.myGroup.currentValue.peopleAndJobCount !==
                    changes.myGroup.previousValue.peopleAndJobCount)
        );
    }

    skipAssessment() {
        this.displayTakeAssessment = false;
        this.localStorageService.setItem(
            this.showSkipAssessmentFooterKey,
            true
        );
    }

    takeAssessment() {
        this.displayTakeAssessment = false;
        this.takeAssessmentFn.emit();
        this.cancel.emit();
    }

    getTakeAssessmentStatus(): boolean {
        return this.displayTakeAssessment;
    }

    displayEditForm(): boolean {
        return !this.displayTakeAssessment;
    }

    getAssessmentFooter(): boolean {
        return this.localStorageService.getItem<boolean>(
            this.showSkipAssessmentFooterKey
        );
    }

    getGroupEditStyle() {
        if (this.isSelfServe) {
            return 'form formInPeekPanel selfServeForm';
        } else {
            return 'form formInPeekPanel';
        }
    }

    private resetTeamCrossFunctionIdChosen(): void {
        this.teamCrossFunctionIdChosen = {
            crossFunctionId: DreamTeamCrossFunctionId.Unknown,
            display: this.TR.key(
                'teamConfig.team-crossFunction.input-placeholder'
            )
        };
    }

    private resetTeamFunctionChosen(): void {
        this.teamFunctionChosen = {
            teamFunctionType: DreamTeamFunctionType.Unknown,
            display: this.TR.key('teamConfig.team-function.input-placeholder')
        };
    }

    private resetTeamImprovementChosen(): void {
        this.teamImprovementChosen = {
            teamImprovementId: TeamImprovementId.Unknown,
            display: this.TR.key(
                'teamConfig.team-improvement.input-placeholder'
            )
        };
    }

    private updateTeamImprovementFromGroup(group: Group): void {
        const groupTeamImprovement = group.teamImprovementIds[0];
        if (
            groupTeamImprovement !== undefined &&
            groupTeamImprovement !== TeamImprovementId.Unknown
        ) {
            // update the component's chosen team improvement to be the group's
            this.teamImprovementChosen = this.teamImprovementDisplays.find(
                (improvement) =>
                    improvement.teamImprovementId === groupTeamImprovement
            );
            // if the group has Other for team improvement
            if (group.teamImprovementIds.includes(TeamImprovementId.Other)) {
                // set the component's other area to the groups' other area
                this.otherTeamImprovementArea = group.otherTeamImprovement;
            } else {
                this.otherTeamImprovementArea = null;
            }
        } else {
            this.resetTeamImprovementChosen();
        }
    }

    private updateTeamFunctionChosenFromGroup(group: Group): void {
        if (group.teamFunctionType !== DreamTeamFunctionType.Unknown) {
            this.teamFunctionChosen = this.teamFunctionDisplays.find(
                (func) => func.teamFunctionType === group.teamFunctionType
            );
            if (group.teamFunctionType === DreamTeamFunctionType.Other) {
                this.otherTeamFunction = group.otherTeamFunction;
            } else {
                this.otherTeamFunction = null;
            }
        } else {
            this.resetTeamFunctionChosen();
        }
    }

    private updateTeamCrossFunctionIdChosenFromGroup(group: Group): void {
        if (group.crossFunctionId !== DreamTeamCrossFunctionId.Unknown) {
            this.teamCrossFunctionIdChosen =
                this.teamCrossFunctionIdDisplays.find(
                    (func) => func.crossFunctionId === group.crossFunctionId
                );
        } else {
            this.resetTeamCrossFunctionIdChosen();
        }
    }

    // to facilitate multiselecting team improvement ids in the future
    private convertObjectToTeamImprovementIdsArray(
        displays: DreamTeamImprovementDisplay[]
    ): TeamImprovementId[] {
        return displays.map((d) => d.teamImprovementId);
    }

    private resetDelta() {
        this.addedDelta.length = 0;
        this.removedDelta.length = 0;
    }
}
